<template>
  <div class="Chrome noSel" style="overflow-y: hidden;">
	  <div style="margin-left:25px;width:950px">
		<div>我们推荐使用谷歌浏览器，在真实注册中也需要您安装谷歌浏览器去完成注册流程！</div>
		<br>
		<h3>谷歌浏览器(Google Chrome) v 83.0.4103.106版</h3>
		<br>
		<div>请根据自身系统选择下载版本，如何查看系统是32位还是64位，<a href="http://robotrs.lenovo.com.cn/ZmptY2NtYW5hZ2Vy/p4data/Rdata/Rfiles/148.html" style="color:#000;text-decoration : underline;">点击这里</a></div>
		<div class="btn1"><a href="http://cr5.198254.com/83.0.4103.106_chrome_installer.zip"><span style="margin-top: 15px;">32位系统下载</span></a></div>
			<div class="btn2" style="margin-left:60px"><a href="http://cr5.198254.com/83.0.4103.106_chrome_x64.zip"><span>64位系统下载</span></a></div>
		<div style="height:30px"></div>
		<div><b>对于其它的双内核浏览器请切换到极速模式(webkit内核、Chrome内核)</b></div>
		<br>
		<h3>360浏览器内核切换操作</h3>
		<br>
		<div>切换“极速模式”</div>
		<br>
		<img src="../../assets/images/chrome.png" alt="360极速模式切换">
	</div>
  </div>
</template>
<script>

export default {
  name: "Chrome",
  components: {
  },
  data: function() {
    return {}
  },
  created(){
	  this.goPost()
  },
   mounted () {
   },
   methods: {

   }
};
</script>
<style lang="scss" scoped>
.Chrome{
	h3 {
			font-size: 19px;
			color: #333;
			line-height: 30px;
			border-left: 5px solid #0cad12;
			border-bottom: 1px solid #d6d6d8;
			padding: 10px;
			-webkit-margin-before: 0;
			-webkit-margin-after: 0;
			font-weight: 400;
		}
		.btn1{
			border-radius: 10px;
			display: inline-block;
			width: 200px;
			height: 65px;
			text-align: center;
			color: #fff;
			margin-top: 20px;
			cursor: pointer;
			background: #11c382;
		}
		.btn2{
			border-radius: 10px;
			display: inline-block;
			width: 200px;
			height: 65px;
			text-align: center;
			color: #fff;
			margin-top: 20px;
			cursor: pointer;
			background: #0088cc;
		}
		a{
			font-size: 20px;
			line-height: 65px;
			text-decoration : none;
			color:#fff;
		}
}

</style>
